import React, { useEffect, useState } from 'react'
import { Frame } from 'components'
import JobBoardForm from './JobBoardForm'
import JobBoardFormBipoc from './JobBoardFormBipoc'
import JobBoardList from './JobBoardList'
import { getUserJobBoardPosts, useHasActiveSubscription, useContent } from 'utils'
import { Redirect } from 'react-router'

export const SubscriberJobBoardCreate = (props) => {
  const { hasActiveSubscription, isLoading: subscriptionLoading } = useHasActiveSubscription(
    props.user?.id,
  )
  const { useBipocJobBoard, isLoading: contentLoading } = useContent()

  if (!subscriptionLoading && !hasActiveSubscription) {
    return <Redirect to="/packages" />
  }
  return (
    <Frame maxWidth="xs" user={props.user}>
      {useBipocJobBoard ? (
        <JobBoardFormBipoc {...props} />
      ) : (
        <JobBoardForm {...props} />
      )}
    </Frame>
  )
}

export const SubscriberJobBoardEdit = (props) => {
  const [post, setPost] = useState()
  const { hasActiveSubscription, isLoading: subscriptionLoading } = useHasActiveSubscription(
    props.user?.id,
  )
  const { useBipocJobBoard, isLoading: contentLoading } = useContent()

  useEffect(() => {
    if (!props.match.params.id || post) return
    getUserJobBoardPosts().then((posts) => {
      const foundPost = posts.find((post) => post.id === props.match.params.id)
      if (foundPost) {
        setPost({
          id: foundPost.id,
          ...foundPost,
          startDate: foundPost.startDate?.toDate(),
          endDate: foundPost.endDate?.toDate(),
        })
      } else {
        props.history.push('/job_board')
      }
    })
  }, [post, props.history, props.match.params.id])

  if (!subscriptionLoading && !hasActiveSubscription) {
    return <Redirect to="/packages" />
  }

  return (
    <Frame maxWidth="xs" user={props.user}>
      {post && (
        useBipocJobBoard ? (
          <JobBoardFormBipoc defaultValues={post} {...props} />
        ) : (
          <JobBoardForm defaultValues={post} {...props} />
        )
      )}
    </Frame>
  )
}

export const SubscriberJobBoardList = (props) => {
  const { hasActiveSubscription, isLoading: subscriptionLoading } = useHasActiveSubscription(
    props.user?.id,
  )
  if (!subscriptionLoading && !hasActiveSubscription) {
    return <Redirect to="/packages" />
  }

  return (
    <Frame maxWidth="xs" user={props.user}>
      <JobBoardList {...props} />
    </Frame>
  )
}
